<template>
  <div>
    <Func4PrintHeader />

    <template v-for="credenciados in redeCredenciada">
      <Func4PrintGroup :key="credenciados.codigo_secao" :credenciados="credenciados.credenciados"
                       :nome="credenciados.descricao_secao"
                       v-if="credenciados.credenciados && credenciados.credenciados.length" />
    </template>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Func4PrintGroup from '@/views/4/print/PrintGroup'
import Func4PrintHeader from '@/views/4/print/PrintHeader'

export default {
  name: 'Func4Print',
  components: { Func4PrintHeader, Func4PrintGroup },
  computed: {
    ...mapGetters('RedeCredenciada', ['redeCredenciada'])
  },
  mounted () {
    document.title = 'Impressão de pesquisa de rede credenciada'
  }
}

</script>
